import { useEffect } from 'react';
import { RpcProvider, useRpc } from '../context/RpcContext';
import { setRpcClient } from '../services/rpc-socket/rpcClient';

export function RpcInitializer() {
  const rpcClient = useRpc();

  useEffect(() => {
    setRpcClient(rpcClient);
  }, [rpcClient]);

  return null;
}

export const withRpcProvider = (Component: any) => (props: any) => {
  return (
    <RpcProvider>
      <RpcInitializer />
      <Component {...props} />
    </RpcProvider>
  );
};

